import { ELogLevel, LoggerType } from '@services/errorService';
import { ensureObjectIsDate } from '@utils/date';

import { isBenefitSettings, isCartSettings, isDeliverySettings, isPaymentSettings } from '../../model';

import { ICartPageSettingsGatewayResponse } from './model';

/**
 * Transforms DTO data to last order with proper types.
 * @param data The DTO object.
 * @param logger Logger function that is being called when decoding fails.
 * @return ILastOrder The last order object.
 */
export const cartPageConfigurationFromDto = (
  data: ICartPageSettingsGatewayResponse,
  logger: LoggerType,
): ICartPageSettingsGatewayResponse => {
  const { data: deliveryData, messages: deliveryMessages } = data.aggregatedConfiguration.deliveryConfiguration;

  const result: ICartPageSettingsGatewayResponse = {
    aggregatedConfiguration: {
      cartConfiguration: { ...data.aggregatedConfiguration.cartConfiguration },
      deliveryConfiguration: {
        data: {
          ...deliveryData,
          freeDeliveryGlobalFrom: ensureObjectIsDate(deliveryData.freeDeliveryGlobalFrom),
          freeDeliveryGlobalTo: ensureObjectIsDate(deliveryData.freeDeliveryGlobalTo),
        },
        messages: deliveryMessages,
      },
      paymentConfiguration: { ...data.aggregatedConfiguration.paymentConfiguration },
      benefitConfiguration: { ...data.aggregatedConfiguration.benefitConfiguration },
    },
  };

  if (!isCartSettings(result.aggregatedConfiguration.cartConfiguration.data)) {
    logger({ logLevel: ELogLevel.WARNING, logMessage: 'Could not decode CartSettings' });
  }

  if (!isDeliverySettings(result.aggregatedConfiguration.deliveryConfiguration.data)) {
    logger({ logLevel: ELogLevel.WARNING, logMessage: 'Could not decode DeliverySettings' });
  }

  if (!isPaymentSettings(result.aggregatedConfiguration.paymentConfiguration.data)) {
    logger({
      logLevel: ELogLevel.WARNING,
      logMessage: 'Could not decode PaymentSettings',
      additionalData: [{ key: 'PaymentSettings', data: result.aggregatedConfiguration.paymentConfiguration }],
    });
  }

  if (!isBenefitSettings(result.aggregatedConfiguration.benefitConfiguration.data)) {
    logger({ logLevel: ELogLevel.WARNING, logMessage: 'Could not decode BenefitSettings' });
  }

  return result;
};
